import { Component } from "react";
import View from "./view";
import "./index.css";
import {
  getFormForMachine,
  createMachineInspection,
  getMachine,
  getFaultyList
} from "../../../backend/machines";
import withRouter from "react-router-dom/withRouter";
import { connect } from "react-redux";

class MachineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      machine: props.machine,
      machine_id: props.match.params.machine_id,
      form_id: props.match.params.form_id,
      savedForm: Boolean(props.match.params.form_id),
      dialogVisible: false,
      loading: false,
      machine_hours: props.machine.machine_hours,
      status: '',
      faulty_list: null
    };
    this._leave = this._leave.bind(this);
    this._valid = this._valid.bind(this);
    this._toggleSubmitDialog = this._toggleSubmitDialog.bind(this);
    this._editMachine = this._editMachine.bind(this);
  }

  async componentDidMount() {
    const { form_id, machine_id } = this.state;
    const faulty_list = await getFaultyList(0)
    const m_faulty_list = [];
    faulty_list.map(
      ({id,type, name}, key) => type === 'Machine' && (
          m_faulty_list.push({ key:key, value: id, label: name })
      )
  )
    if (form_id || machine_id) this.setState({ loading: true });

    if (form_id) {
      this.setState({ ...(await getFormForMachine(form_id)), loading: false });
    }
    if (machine_id) {
      this.setState({ machine: await getMachine(machine_id), loading: false, m_faulty_list: m_faulty_list });
    }
  }

  _change(prop, ev = false, sel = false) {
    return event =>
      this.setState({
        [prop]: ev ? (sel ? event.value : event) : event.target.value
      });
  }

  _valid() {
    return (
      this.state.priority !== undefined &&
      this.state.machine_hours !== undefined &&
      this.state.machine_id !== undefined &&
      this.state.status !== undefined &&
      this.state.inspection_pass !== undefined &&
      this.state.inspection_note !== undefined &&
      this.state.require_swap !== undefined &&
      (this.state.require_swap === true
        ? this.state.one_way_swap !== undefined && (
          this.state.one_way_swap !== true ? this.state.new_machine_id !== undefined : true
        )
        : true)
    );
  }

  _leave(event) {
    this._toggleSubmitDialog();
  }

  _toggleSubmitDialog() {
    this.setState({ dialogVisible: !this.state.dialogVisible });
  }
  _editMachine(index, inputType = "input", prop) {
    return event => {
      let value;
      if (inputType === "radio") {
        value = event;
      } else if (inputType === "select") {
        value = event.value;
      } else if (inputType === "input") {
        value = event.target.value;
      }

      let { machine } = this.state;
     
        if( prop === 'status'){
            this.setState({status : value});
        } else if (prop === 'faulty_reason'){
            let text = event.label;
            let other = event.label === 'Other' ? 1 : 0;
            machine = { ...machine,faulty_reason: { id : value, text: text, other: other } }
            this.setState({ machine });
        } else if (prop === 'faulty_reason_text'){
            // return faulty_reason.text = event.target.value
            machine = { ...machine,faulty_reason: { id: this.state.machine.faulty_reason.id, text: event.target.value, other:1 } }
            this.setState({ machine });
        }else{
          machine = { ...machine, hire_status: value };
            this.setState({ machine });
        }
    
    };
  }
  async _upload() {
    const {
      inspection_note,
      inspection_pass,
      require_swap,
      status,
      machine_hours,
      one_way_swap,
      new_machine_id,
      priority,
      machine
    } = this.state;
    const { store_id } = this.state.machine;
    const { machine_id } = this.props.match.params;

    this.setState({ uploading: true });
    await createMachineInspection({
      inspection_note,
      inspection_pass,
      require_swap,
      machine_hours,
      store_id,
      priority,
      one_way_swap,
      new_machine_id,
      status,
      machine_id,
      machine
    });
    this.setState({ uploading: false, savedForm: true });
    this.props.history.goBack();
    // this.props.history.push(`/machines/${store_id}`);
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  render() {
    return View.call(this);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    machine: state.selections.machine || { machine_hours: 0 }
  };
};

export default withRouter(connect(mapStateToProps)(MachineForm));



// WEBPACK FOOTER //
// ./src/screens/machines/machine-form/index.js